export const DEF_EVENT_HANDLER = {
    onNodeClick: (event, x, y) => {
        console.log('* Default click handler: node', event, x, y);
    },
    onEdgeClick: (event, x, y) => {
        console.log('* Default click handler: edge', event, x, y);
    },
    onNodeMouseover: (event) => {
        // console.log('* Mouse over: node', event)
    },
    onEdgeMouseover: (event) => {
        // console.log('* Mouse over: edge', event)
    },
    onBackgroundClick: (layer, object) => {
        console.log('* BG click event');
    },
    onSelect: (nodes, edges) => {
        console.log('* Selected', nodes, edges);
    }
};
